<template>
  <div>
    <div id="dplayer" class="play-root"></div>
  </div>
</template>

<script>
import DPlayer from "dplayer";
export default {
  data() {
    return {
      dp: null,
    };
  },
  props: {
    url: {
      type: String,
      default: ""
    }
  },
  methods: {
    onPlay() {
      this.dp.play();
    },
    begin(url) {
      const dp = new DPlayer({
        // 配置参数
        container: document.getElementById("dplayer"),
        autoplay: false,
        theme: "#FADFA3",
        loop: false,
        lang: "zh-cn",
        preload: "auto",
        volume: 0.7,
        video: {
          url: url,
          type: "auto"
        }
      });
      // 禁止右键下载视频
      document.oncontextmenu = new Function("event.returnValue=false;");
      document.onselectstart = new Function("event.returnValue=false;");
      // 修改循环播放显示
      document
        .getElementsByClassName("dplayer-setting-item dplayer-setting-loop")[0]
        .getElementsByClassName("dplayer-label")[0].innerText = "循环播放";
      // 修改倍速播放显示
      document
        .getElementsByClassName("dplayer-setting-item dplayer-setting-speed")[0]
        .getElementsByClassName("dplayer-label")[0].innerText = "播放倍速";
    }
  },
  watch: {
    url: function(newVal, oldVal) {
      this.newUrl = newVal; 
      newVal && this.begin(newVal); //newVal存在的话执行begin函数
    }
  },
  mounted() {}
};
</script>

<style>
</style>